// Dispatch ids for FileManager row/menu actions. Single source of truth shared
// by the custom list/grid views, their menus, and useFileActionHandler.
export enum FileAction {
  CREATE_IMAGE_LAYER = 'create_image_layer',
  REMOVE_IMAGE_LAYER = 'remove_image_layer',
  DELETE_FILES = 'delete_files',
  DELETE_ALL = 'delete_all',
  PREVIEW_FILE = 'preview_file',
  REUPLOAD_FILE = 'reupload_file',
  MOVE_FILE = 'move_file',
  MOVE_ALL = 'move_all',
  FILE_PERMISSIONS = 'file_permissions',
  RENAME_FILE = 'rename_file',
  RESTORE_FILE = 'restore_file',
  RESTORE_ALL = 'restore_all',
  PERMANENTLY_DELETE_FILE = 'permanently_delete_file',
  PERMANENTLY_DELETE_ALL = 'permanently_delete_all',
  DOWNLOAD_FILES = 'download_files',
  DOWNLOAD_ALL = 'download_all',
  CHANGE_SELECTION = 'change_selection',
}
